import { useTranslation } from "react-i18next";
import { Avatar } from "@/shared/ui";

interface Props {
  name: string;
  email: string | null;
  onClick: () => void;
}

export default function ProfileMenuHeader({ name, email, onClick }: Props) {
  const { t } = useTranslation("Sidebar");

  return (
    <button
      type="button"
      aria-label={t("myProfile")}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className="w-full flex items-center gap-3 pb-5 text-left cursor-pointer">
      <Avatar name={name} size={40} />
      <div className="min-w-0 flex-1">
        <p className="truncate text-label-sm content-base-primary">{name}</p>
        {email && <p className="truncate text-body-regular-xs content-base-secondary">{email}</p>}
      </div>
    </button>
  );
}

